import { render } from "./clients.vue?vue&type=template&id=406c2a0d&scoped=true"
import script from "./clients.vue?vue&type=script&lang=js"
export * from "./clients.vue?vue&type=script&lang=js"

import "./clients.vue?vue&type=style&index=0&id=406c2a0d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406c2a0d"]])

export default __exports__